export enum ScheduleModalMode {
    Create = 1,
    Edit = 2,
    TurnOn = 3,
}
